// Keep animation ownership and opening order across all modal close paths.
const states = new WeakMap();
let openingOrder = 0;

const stateOf = modal => {
    if (!states.has(modal)) states.set(modal, {timers: new Set(), order: 0});
    return states.get(modal);
};

export const cancelModalTimers = modal => {
    const state = stateOf(modal);
    state.timers.forEach(timer => clearTimeout(timer));
    state.timers.clear();
};

export const scheduleModal = (modal, callback, delay) => {
    const state = stateOf(modal);
    const timer = setTimeout(() => {
        state.timers.delete(timer);
        callback();
    }, delay);
    state.timers.add(timer);
};

const openModals = () => {
    // A selector list also works in older browsers without :is().
    const modals = document.querySelectorAll('.modal.open.show:not(.notification), .modal.open[data-modal-opening="1"]:not(.notification)');
    modals.forEach(modal => {
        const state = stateOf(modal);
        // Server-rendered and AJAX-inserted modals may bypass alertFunc().
        if (!state.order) state.order = ++openingOrder;
    });
    return modals;
};

export const markModalOpened = modal => {
    // Register already-open server modals before assigning the new opening.
    openModals();
    stateOf(modal).order = ++openingOrder;
};

export const topOpenModal = () => {
    let top = null;
    openModals().forEach(modal => {
        if (!top || stateOf(modal).order > stateOf(top).order) top = modal;
    });
    return top;
};
